import React, { useState, useEffect, useRef } from 'react';
import { getAllUsers } from '../../api/authenticateAPIs';
import { useTranslation } from 'react-i18next';

export default function UsersMultiselect({ selectedValues, onChange }) {
    
    const [t] = useTranslation('global');
    const [users, setUsers] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const fetchUsers = async () => {
            try {
              const response = await getAllUsers();
              const users = response.map((user) => ({
                value : user.id,
                label: `${user.userFirstname} ${user.userLastname}`,
              }));
              setUsers(users);
            } catch (error) {
              console.error("Error fetching data: ", error);
            };
          }
        fetchUsers();
    },[]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false); // Close dropdown
            }
        };

        document.addEventListener('mousedown', handleClickOutside); // Listen for clicks
        return () => {
            document.removeEventListener('mousedown', handleClickOutside); // Cleanup on unmount
        };
    }, []);

    const handleSelect = (value) => {
        if (selectedValues.includes(value)) {
            // Remove value
            onChange({ target: { value: selectedValues.filter((v) => v !== value) } });
        } else {
            // Add value
            onChange({ target: { value: [...selectedValues, value] } });
        }
    };

    const handleDelete = (value) => {
        onChange({ target: { value: selectedValues.filter((v) => v !== value) } });
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    
    const filteredUsers = users.filter((user) =>
        user.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="mill-multiselect" ref={dropdownRef}>
            <label>{t('users')}</label>
            <div className="multiselect-line" onClick={toggleDropdown}>
                <div className="selected-values">
                    {selectedValues.map((value) => (
                        <span key={value} className="selected-chip">
                            {users.find((u) => u.value === value)?.label || value}
                            <button className="delete-chip" onClick={() => handleDelete(value)}>
                                &times;
                            </button>
                        </span>
                    ))}
                </div>
                <span className="dropdown-icon material-symbols-outlined">
                    {isDropdownOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
            </div>
            {isDropdownOpen && (
                <div className="dropdown-menu">
                    <div className='search-input-wrapper'>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={t('search')}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <ul className="dropdown-list">
                        {filteredUsers.map((user) => (
                            <li key={user.value}
                                className={`dropdown-item ${
                                    selectedValues.includes(user.value) ? "selected" : ""
                                }`}
                                onClick={() => handleSelect(user.value)}
                            >
                                {user.label}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}